import { ICountry } from '../../models/country'

export enum RecoverPasswordTypeKeys {
  RESET_RECOVER_PASSWORD_FIELDS = 'RESET_RECOVER_PASSWORD_FIELDS',
  SET_RECOVER_PASSWORD_EMAIL = 'SET_RECOVER_PASSWORD_EMAIL',
  SET_RECOVER_PASSWORD_PHONE = 'SET_RECOVER_PASSWORD_PHONE',
  SET_RECOVER_PASSWORD_CALLING_CODE = 'SET_RECOVER_PASSWORD_CALLING_CODE',
  SET_RECOVER_PASSWORD_COUNTRY = 'SET_RECOVER_PASSWORD_COUNTRY',
  REQUEST_RECOVER_CODE = 'REQUEST_RECOVER_CODE',
  REQUESTING_RECOVER_CODE = 'REQUESTING_RECOVER_CODE',
  REQUEST_RECOVER_CODE_SUCCESSFUL = 'REQUEST_RECOVER_CODE_SUCCESSFUL',
  REQUEST_RECOVER_CODE_FAILED = 'REQUEST_RECOVER_CODE_FAILED',
  SET_RECOVER_PASSWORD_VERIFICATION_CODE = 'SET_RECOVER_PASSWORD_VERIFICATION_CODE',
  SET_RECOVER_PASSWORD_NEW_PASSWORD = 'SET_RECOVER_PASSWORD_NEW_PASSWORD',
  SET_RECOVER_PASSWORD_REPEAT_NEW_PASSWORD = 'SET_RECOVER_PASSWORD_REPEAT_NEW_PASSWORD',
  RECOVER_PASSWORD = 'RECOVER_PASSWORD',
  RECOVERING_PASSWORD = 'RECOVERING_PASSWORD',
  RECOVER_PASSWORD_SUCCESSFUL = 'RECOVER_SUCCESSFUL_PASSWORD',
  RECOVER_PASSWORD_FAILED = 'RECOVER_FAILED_PASSWORD'
}

export interface IResetRecoverPasswordFieldsAction {
  type: typeof RecoverPasswordTypeKeys.RESET_RECOVER_PASSWORD_FIELDS
  [extraProps: string]: unknown
}

export interface ISetRecoverPasswordEmailAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_EMAIL
  payload: string
  [extraProps: string]: unknown
}

export interface ISetRecoverPasswordPhoneAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_PHONE
  payload: string
}

export interface ISetRecoverPasswordCallingCodeAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_CALLING_CODE
  payload: string
}

export interface ISetRecoverPasswordCountryAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_COUNTRY
  payload: ICountry
}

export interface IRequestRecoverCodeAction {
  type: typeof RecoverPasswordTypeKeys.REQUEST_RECOVER_CODE
  [extraProps: string]: unknown
}

export interface ISetIsRequestingRecoverCodeAction {
  type: typeof RecoverPasswordTypeKeys.REQUESTING_RECOVER_CODE
  [extraProps: string]: unknown
}

export interface IRequestRecoverCodeSuccessfulAction {
  type: typeof RecoverPasswordTypeKeys.REQUEST_RECOVER_CODE_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IRequestRecoverCodeFailedAction {
  type: typeof RecoverPasswordTypeKeys.REQUEST_RECOVER_CODE_FAILED
  payload: string
  [extraProps: string]: unknown
}

export interface ISetRecoverPasswordVerificationCodeAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_VERIFICATION_CODE
  payload: string
  [extraProps: string]: unknown
}

export interface ISetRecoverPasswordNewPasswordAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_NEW_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface ISetRecoverPasswordRepeatNewPasswordAction {
  type: typeof RecoverPasswordTypeKeys.SET_RECOVER_PASSWORD_REPEAT_NEW_PASSWORD
  payload: string
  [extraProps: string]: unknown
}

export interface IRecoverPasswordAction {
  type: typeof RecoverPasswordTypeKeys.RECOVER_PASSWORD
  [extraProps: string]: unknown
}

export interface ISetIsRecoveringPasswordAction {
  type: typeof RecoverPasswordTypeKeys.RECOVERING_PASSWORD
  [extraProps: string]: unknown
}

export interface IRecoverPasswordSuccessfulAction {
  type: typeof RecoverPasswordTypeKeys.RECOVER_PASSWORD_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IRecoverPasswordFailedAction {
  type: typeof RecoverPasswordTypeKeys.RECOVER_PASSWORD_FAILED
  payload: string
  [extraProps: string]: unknown
}

export type RecoverPasswordActionTypes =
  | IResetRecoverPasswordFieldsAction
  | ISetRecoverPasswordEmailAction
  | ISetRecoverPasswordPhoneAction
  | ISetRecoverPasswordCallingCodeAction
  | ISetRecoverPasswordCountryAction
  | IRequestRecoverCodeAction
  | ISetIsRequestingRecoverCodeAction
  | IRequestRecoverCodeSuccessfulAction
  | IRequestRecoverCodeFailedAction
  | ISetRecoverPasswordVerificationCodeAction
  | ISetRecoverPasswordNewPasswordAction
  | ISetRecoverPasswordRepeatNewPasswordAction
  | IRecoverPasswordAction
  | ISetIsRecoveringPasswordAction
  | IRecoverPasswordSuccessfulAction
  | IRecoverPasswordFailedAction
